import { Component, OnInit } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { validateForm } from "src/app/shared/validators";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-field-surveymcssh",
    template: `<ng-container>
      <div>
        <div class="rating-row mt-3 ml-2 mr-2">
          <span
            class="rating-question"
            [innerHTML]="props.question?.questionNarrative | safeStyleHtml"
          ></span>
        </div>
    
        <table class="w-100">
          <tr class="rating-check-option">
            @for (option of props.question.options; track option) {
              <td
                [style.width.%]="100 / props.question.options.length"
                >
                {{ option.name }}
              </td>
            }
          </tr>
          <tr class="rating-check-option">
            @for (option of props.question.options; track option) {
              <td
                [style.width.%]="100 / props.question.options.length"
                >
                <mat-checkbox
                  [formlyAttributes]="field"
                  [disabled]="props.disabled"
                  [value]="option.value"
                  [id]="option.id"
                  [ngModel]="myModel[option.value]"
                  (ngModelChange)="onModelChange($event, option.value)"
                  >
                </mat-checkbox>
              </td>
            }
          </tr>
        </table>
    
        <mat-hint class="error ml-2" align="start">{{
          getErrorMessage(props.question.id)
        }}</mat-hint>
      </div>
      @if (props.question?.showCommentBox) {
        <br />
        <mat-form-field appearance="fill" floatLabel="always" class="comments">
          <mat-label>Comments</mat-label>
          <textarea
            [id]="props.question?.id + '-comments'"
            [ngModel]="commentModel"
            rows="4"
            class="form-field"
            matInput
            (blur)="onBlurEvent($event)"
            [disabled]="props.disabled"
          ></textarea>
        </mat-form-field>
      }
    </ng-container>`,
    styleUrls: ["./common.css"],
    standalone: false
})
export class FormlyFieldSurveyMcsshComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  public myModel = {};
  public commentModel: string;
  commentKey: string;

  getErrorMessage(key: string): string {
    return validateForm(this.form, key);
  }

  ngOnInit(): void {
    const modelValue = this.model[this.key.toString()] || "";

    this.props.question.options.forEach((item) => {
      this.myModel[item["value"]] = modelValue == item["value"];
    });

    this.commentKey = this.key.toString() + "-comments";
    this.commentModel = this.model[this.commentKey] || "";
  }

  public onModelChange(checked: any, value: any) {
    this.myModel[value] = !this.myModel[value];
    if (checked) {
      for (const k in this.myModel) {
        if (k !== value) {
          this.myModel[k] = false;
        }
      }
    }
    this.formControl.setValue(
      Object.keys(this.myModel)
        .filter((i) => this.myModel[i] === true)
        .map((i) => i)
        .join("")
    );
  }

  onBlurEvent(event: any) {
    this.model[this.commentKey] = event.target.value;
    this.formControl.updateValueAndValidity();
  }
}
